// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2RK7K","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2MBhB"};